<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search @change="queryData" >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theSettle" placeholder="请选择结算"  :allowClear="true">
				<a-select-option v-for="(item,index) in settleLogList" :key="item.PID" :value="item.PID">{{item.StartTime}}</a-select-option>
			</a-select>
			<label>楼</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theLou"  :allowClear="true">
				<a-select-option v-for="(item,index) in louList" :key="item.lou" :value="item.lou">{{item.lou}}</a-select-option>
			</a-select>
			<a-button  size="small"  icon="search" @click="queryDataList" style="margin-left: 1.25rem;">查找</a-button>
			<a-button size="small"   icon="printer" @click="printAll" style="margin-left: 1.25rem;" :loading="printAllLoading" :disabled="dataList.length == 0">全部打印</a-button>
			<a-button size="small"   icon="property-safety" @click="chargePost" style="margin-left: 1.25rem;" :loading="chargeSubmitFlag" :disabled="dataList.length == 0">缴费</a-button>
			<a-button size="small"  v-if="false"    icon="bell"   :loading="warningSubmitFlag" @click="warningAllSubmit" style="margin-left: 1.25rem;">提醒缴费</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="600"   ref="mTable" show-overflow="title"
						  resizable highlight-hover-row :loading="loading"    size="mini" :cell-style="cellClassName"
						  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						  :checkbox-config="{trigger: 'row', highlight: true, range: true}">
			<vxe-table-column type="checkbox" width="45"></vxe-table-column>
			<vxe-table-column title="打印" field="PID" width="65">
				<template #default="{ row }">
					<a-button  size="small"  type="link"  @click="printIt(row)">打印</a-button>
				</template>
			</vxe-table-column>
			<vxe-table-column title="用户号" field="customerNum" width="75"></vxe-table-column>
			<vxe-table-column title="用户名" field="CustomerName" ></vxe-table-column>
			<vxe-table-column title="手机" field="CustomerMobile"></vxe-table-column>
			<vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
			<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
			<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
			<vxe-table-column title="表状态" field="MeterState" :formatter="getMeterState"></vxe-table-column>
			<vxe-table-column title="单价" field="PriceKindName" ></vxe-table-column>
			<vxe-table-column title="扣费读数" field="LastDeRead"></vxe-table-column>
			<vxe-table-column title="阶梯起始" field="destartread"></vxe-table-column>
			<vxe-table-column title="表读数" field="MeterRead"></vxe-table-column>
			<vxe-table-column title="换表底数" field="changend"></vxe-table-column>
			<vxe-table-column title="抄表时间" field="MeterReadTime" :formatter="getTimeFormatter"></vxe-table-column>
			<vxe-table-column title="用量">
				<template #default="{ row }">
					<span>
						{{getUseCount(row)}}
					</span>
				</template>
			</vxe-table-column>
			<vxe-table-column title="阶梯"  field="formula"></vxe-table-column>
			<vxe-table-column title="减免"  field="minusderead"></vxe-table-column>
			<vxe-table-column title="转到虚表" field="tovirtual"></vxe-table-column>
			<vxe-table-column title="扣费金额"   field="DeMoney"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				theNeighbor:undefined,
				theSettle:undefined,
				theLou:null,
				selectedRowKeys:[],
				neighborList:[],
				settleLogList:[],
				dataList:[],
				louList:[],
				loading:false,
				chargeSubmitFlag:false,
				warningSubmitFlag:false,
				printAllLoading:false,
			}
		},
		methods:{
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(this.selectedRowKeys.includes(row.MDLID)){
					style = {
						backgroundColor: '#FFE48A',
					}
				}else{
					style = {
							'color':'#333',
							fontFamily:"arial,sans-serif"
					}	
				}	
				return style;
			},
			selectAllEvent ({ checked, records }) {
				if(checked){
					for(var i = 0;i<records.length;i++){
						this.selectedRowKeys.push(records[i].MDLID);
					}
				}else{
					this.selectedRowKeys = [];
				}
			},
			selectChangeEvent({ checked, records }) {
				this.selectedRowKeys = [];
				for(var i = 0;i<records.length;i++){
					this.selectedRowKeys.push(records[i].MDLID);
				}
			},
			getAdminIdBySettle:function(){
				let result = null;
				for(var i = 0;i<this.settleLogList.length;i++){
					let item = this.settleLogList[i];
					if(item.PID == this.theSettle){
						result = item.AdminID;
						break;
					}
				}
				return result;
			},
			printAll:function(){
				if(this.dataList.length == 0){
					this.$message.error('没有可打印的数据');
					return
				}
				if(this.theLou == null){
					this.$message.error('请选择楼');
					return
				}
				var ids = [];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					ids.push(item.MDLID);
				}
				let userId = this.getAdminIdBySettle();
				let url = null;
				if(this.dataList[0].HouseKindID == 4){//企业
					url =  this.Api.getLastUrl('/report/postChargeEnterpriseAll');
				}else{//普通
					url =  this.Api.getLastUrl('/report/postChargeNormalAll');
				}
				window.open(url+'?theIds=' + ids.join(',')+"&userId="+userId, "_blank");
			},
			chargePost:function(){
				if(this.selectedRowKeys.length == 0){
					this.$message.error('请选择记录');
					return;
				}
				this.chargeSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_POST_PAY_CHARGE_URL);
				let param = {mdlIds:this.selectedRowKeys.join(',')};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.chargeSubmitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('操作成功');
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.chargeSubmitFlag = false;
					console.log(error);
				});
			},
			warningAllSubmit:function(){
				if(this.selectedRowKeys.length == 0){
					this.$message.error('请选择用户');
					return ;
				}
				this.warningSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_POST_PAY_WARNING_ALL_URL);
				let param = {mdlIds:this.selectedRowKeys.join(',') ,neighborName:this.theNeighbor.label};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.warningSubmitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('操作成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.warningSubmitFlag = false;
					console.log(error);
				});				
			},
			printIt:function(item){
				let theId = item.MDLID;
				let userId = this.getAdminIdBySettle();
				let url = null;
				if(item.HouseKindID == 4){//企业
					url =  this.Api.getLastUrl('/report/postChargeEnterprise');
				}else{//普通
					url =  this.Api.getLastUrl('/report/postChargeNormal');
				}
				window.open(url+'?theId=' + theId+"&userId="+userId, "_blank");
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys;
			},
			queryDataList:function(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return;
				}
				if(this.theSettle == undefined){
					this.$message.error('请选择结算');
					return;
				}
				this.loading = true;
				let param = {neighborId:this.theNeighbor.key,settleId:this.theSettle,lou:this.theLou};
				let url = this.Api.getLastUrl(this.Api.CHARGE_POST_PAY_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				})
			},
			queryData:function(){
				this.theLou = null;
				this.theSettle = null;
				this.querySettleLogs();
				this.queryLouList();
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			querySettleLogs:function(){
				let url = this.Api.getLastUrl(this.Api.CHARGE_POST_PAY_SETTLE_LOGS_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.settleLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryLouList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LIST_LOU_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.louList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getUseCount:function(item){
				if(item.changend>0){
					return item.MeterRead+item.changend-item.LastDeRead;
				}else{
					return item.MeterRead-item.LastDeRead;
				}
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			meterStateCell(record){
				if(record.MeterState !=1){
					return {
						style:{
							'color':'#ff0000',
						}
					}
				}
			},
			customerBalanceCell(record){
				if(record.customerBalance<=0){
					return {
						style:{
							'color':'#ff0000',
						}
					}
				}
			},
		},
		created(){
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
